import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import { DATE_PICKER_LAYOUTS } from "./constants";

export const datePickerDataSchema = z.object({
  value: z.string().optional(),
  min: z.string().optional(),
  max: z.string().optional(),
  placeholder: z.string().optional(),
  ariaLabel: z
    .string()
    .optional()
    .describe('Accessible name, needed by layout="icon" which shows no value.'),
  locale: z.string().optional(),
  size: z.enum(SIZES).optional(),
  layout: z
    .enum(DATE_PICKER_LAYOUTS)
    .optional()
    .describe(
      '"text" sits inside a sentence; "icon" is a button showing a calendar icon alone, for a toolbar.',
    ),
  disabled: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  arrow: z
    .string()
    .optional()
    .transform((value) =>
      value === undefined ? undefined : value !== "false",
    ),
});

export type DatePickerDataProps = z.infer<typeof datePickerDataSchema>;
